import { IDocumento } from '../idocumento';

export interface IAttachmentHeadersResponse {
    docs?: IDocumento[];
    msg?: string;
}